<template>
  <div>
    <com-dialog :visible.sync="visible" :title="type === 'created' ? '创建' : '编辑'" width="40%">
      <template>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="110px"
          class="demo-ruleForm"
        >
          <el-form-item label="身份类别" prop="type">
            <el-select v-model="ruleForm.type" placeholder="请选择身份类别">
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="item in typeTags"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="名称" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="证件号" prop="idCard">
            <el-input v-model="ruleForm.idCard" placeholder="请输入证件号"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="请输入联系方式"></el-input>
          </el-form-item>
          <el-form-item label="地区" prop="area">
            <com-region :regionId.sync="regionId"></com-region>
          </el-form-item>
          <el-form-item label="联系地址" prop="address">
            <el-input v-model="ruleForm.address" placeholder="请输入联系地址"></el-input>
          </el-form-item>
          <el-form-item label="账号" prop="account">
            <el-input v-model="ruleForm.account" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input
              v-model="ruleForm.password"
              :disabled="pwdDisabled"
              placeholder="不设置默认123456"
            ></el-input>
          </el-form-item>
          <el-form-item label="合伙人等级" prop="level" v-if="ruleForm.type === 1">
            <el-select v-model="ruleForm.level" placeholder="请选择" style="width: 100%">
              <el-option
                :label="item.name"
                :value="item.code"
                v-for="item in partnerList"
                :key="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="投资金额" prop="invest">
            <el-input v-model="ruleForm.invest" placeholder="请输入投资金额"></el-input>
          </el-form-item>
          <!-- <el-form-item label="投资区域" prop="investRegion" v-if="ruleForm.level === 'AREA'">
            <com-region :regionId.sync="investRegionId"></com-region>
          </el-form-item>
          <el-form-item
            label="贡献收益分成"
            prop="regionDivide"
            v-if="ruleForm.level === 'AREA' || ruleForm.level === 'CITY'"
          >
            <el-input v-model="ruleForm.regionDivide">
              <template slot="append">%</template></el-input
            >
          </el-form-item> -->
          <el-form-item label="合约" prop="partnerContract">
            <com-upload-file
              accept=".pdf"
              :limit="1"
              :value.sync="ruleForm.partnerContractList"
              @success="handleUploadFile"
              @del-file="handleDelFile"
            ></com-upload-file>
          </el-form-item>
          <el-form-item label="相关证件照" props="idPhotos">
            <com-upload
              :originData="ruleForm.idPhotos"
              @postImage="postImg"
              @deleteImageUrl="delImg"
            ></com-upload>
          </el-form-item>
          <div class="flex justify-end">
            <el-button @click="resetForm('ruleForm')">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')" v-loading="loading"
              >确认</el-button
            >
          </div>
          <el-form-item> </el-form-item>
        </el-form>
      </template>
    </com-dialog>
  </div>
</template>

<script>
import utils from 'my-tools-library'
import { addPartnerApi, partnersLevelApi, updatePartnerApi } from '@/api/partners'

export default {
  data() {
    const checkIdCard = (rule, value, callback) => {
      if (value === '' || value.length < 18) {
        callback(new Error('请输入十八位身份证号码'))
        return
      }

      if (!utils.checkIdCard(value)) {
        callback(new Error('请输入正确的身份证号码'))
        return
      }
      callback()
    }
    const checkPhone = (rule, value, callback) => {
      if (!utils.checkPhone(value)) {
        callback(new Error('请输入正确的手机号码'))
        return
      }
      callback()
    }
    return {
      visible: false,
      type: '',
      loading: false,
      regionId: [],
      investRegionId: [],
      partnerList: [],
      pwdDisabled: false,
      ruleForm: {},
      defaultForm: {
        name: '',
        password: '', // 密码
        level: '', // 等级
        invest: '', // 投资金额
        idCard: '',
        phone: '',
        address: '',
        account: '', // 账号
        area: '', // 地区
        areaCodes: [],
        partnerContract: '', // 合伙人合约
        regionDivide: '', // 合伙人分成
        investRegion: '', // 投资区域
        type: '',
        idPhotos: [] //相关证件照
      },
      rules: {
        type: [{ required: true, message: '请选择身份类别', trigger: 'blur' }],
        name: [{ required: true, message: '请输入合伙人名称', trigger: 'blur' }],
        area: [{ required: true, message: '请选择地区', trigger: 'blur' }],
        investRegion: [{ required: true, message: '请选择投资区域地区', trigger: 'blur' }],
        address: [{ required: true, message: '请输入联系地址', trigger: 'blur' }],
        regionDivide: [{ required: true, message: '请输入区域合伙人分成', trigger: 'blur' }],
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        level: [{ required: true, message: '请选择合伙人等级', trigger: 'blur' }],
        invest: [{ required: true, message: '请输入投资金额', trigger: 'blur' }],
        partnerContract: [{ required: true, message: '请上传合伙人合约', trigger: 'blur' }],
        idCard: [
          {
            required: true,
            validator: checkIdCard,
            trigger: 'change'
          }
        ],
        phone: [
          {
            required: true,
            validator: checkPhone,
            trigger: 'change'
          }
        ]
      },
      typeTags: [
        { label: '合伙人', value: 1 },
        { label: '商家', value: 2 },
        { label: '代理商', value: 3 }
      ]
    }
  },
  watch: {
    regionId: {
      handler(val) {
        if (val.length) {
          this.ruleForm.area = val.at(-1)
          this.ruleForm.areaCodes = val
        }
      },
      deep: true,
      immediate: true
    },
    investRegionId: {
      handler(val) {
        if (val.length) {
          this.ruleForm.investRegion = val.at(-1)
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    open(opt) {
      const { type, row } = opt
      this.type = type
      console.log('row :>> ', row)
      this.ruleForm = utils.deepCopy(this.defaultForm)
      this.regionId = []
      this.investRegionId = []
      this.pwdDisabled = false

      if (type === 'edit') {
        this.ruleForm = utils.deepCopy(row)
        this.regionId = this.ruleForm.areaCodes
        this.investRegionId = this.ruleForm.investRegionCodes || []
        this.pwdDisabled = true
        if (this.ruleForm.regionDivide) this.ruleForm.regionDivide *= 100
        if (this.ruleForm.partnerContract) {
          this.ruleForm.partnerContractList = [
            {
              name: '合伙人合约',
              url: this.ruleForm.partnerContract
            }
          ]
        }
        if (row.idPhotos) this.ruleForm.idPhotos = JSON.parse(row.idPhotos)
        else this.ruleForm.idPhotos = []

        console.log('idPhotos :>> ', this.ruleForm.idPhotos)
      }
      this.getPartnersLevel()
      this.visible = true
    },
    close() {
      this.visible = false
    },
    getPartnersLevel() {
      partnersLevelApi('PARTNER_LEVEL').then((res) => {
        const { value } = res.data.setting
        this.partnerList = JSON.parse(value)
        console.log('res2233 :>> ', this.partnerList)
      })
    },
    postImg(url) {
      console.log('url :>> ', url)
      this.ruleForm.idPhotos.push(url)
    },
    delImg(index) {
      this.ruleForm.idPhotos.splice(index, 1)
    },
    handleUploadFile(res) {
      this.ruleForm.partnerContract = res.data.code
    },
    handleDelFile() {
      this.ruleForm.partnerContract = ''
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.visible = false
    },

    handleParams() {
      const params = { ...this.ruleForm }
      if (params.regionDivide) {
        params.regionDivide /= 100
      }
      params.idPhotos = JSON.stringify(this.ruleForm.idPhotos)
      return params
    },

    handleCReated() {
      let params = this.handleParams()
      if (!this.ruleForm.password) params.password = '123456'
      addPartnerApi(params).then(() => {
        this.$message.success('操作成功')
        this.$emit('success')
        this.visible = false
      })
    },
    handleUpdate() {
      const params = this.handleParams()
      updatePartnerApi(params).then(() => {
        this.$message.success('操作成功')
        this.$emit('success')
        this.visible = false
      })
    },
    submitForm(formName) {
      console.log('object :>> ', this.ruleForm)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type === 'created') {
            this.handleCReated()
            return
          }
          this.handleUpdate()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
